/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SsoimageCategoriesQueryResponse,
  GetApiV1SsoimageCategories401,
  GetApiV1SsoimageCategories500,
} from "../../types/SSOImageController/GetApiV1SsoimageCategories.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SsoimageCategories } from "../../clients/SSOImageController/getApiV1SsoimageCategories.ts";

export const getApiV1SsoimageCategoriesQueryKey = () =>
  [{ url: "/api/v1/ssoimage/categories" }] as const;

export type GetApiV1SsoimageCategoriesQueryKey = ReturnType<
  typeof getApiV1SsoimageCategoriesQueryKey
>;

export function getApiV1SsoimageCategoriesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SsoimageCategoriesQueryKey();
  return queryOptions<
    GetApiV1SsoimageCategoriesQueryResponse,
    ResponseErrorConfig<
      GetApiV1SsoimageCategories401 | GetApiV1SsoimageCategories500
    >,
    GetApiV1SsoimageCategoriesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SsoimageCategories({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os valores do enum ESSOCategory com id e nome. **(Requer Authorization para autenticação)**
 * @summary Buscar categorias SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/categories}
 */
export function useGetApiV1SsoimageCategories<
  TData = GetApiV1SsoimageCategoriesQueryResponse,
  TQueryData = GetApiV1SsoimageCategoriesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SsoimageCategoriesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SsoimageCategoriesQueryResponse,
        ResponseErrorConfig<
          GetApiV1SsoimageCategories401 | GetApiV1SsoimageCategories500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1SsoimageCategoriesQueryKey();

  const query = useQuery(
    {
      ...getApiV1SsoimageCategoriesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1SsoimageCategories401 | GetApiV1SsoimageCategories500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
